import axios from "axios";
import TTFSnackbar from "component/AppSnackbars/TTFSnackbar";
import useOpenSnackbar from "custom-hooks/snacbar/useOpenSnackbar";
import React, { useContext } from "react";
import { BrowserRouter } from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
import { StackS } from "./stacks";
import "react-datepicker/dist/react-datepicker.css";


function App() {
  const { signOut } = useContext(AuthContext);
  const { openSnackbar, severity, message, openToast, setOpenToast, duration } =
    useOpenSnackbar();

  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("ttf-token");

      config.headers.Authorization = `Bearer ${token}`;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response) {
        if (error.response.status === 401) {
          signOut();
        }else if(error.response.status === 404){
          
        } else {
          openSnackbar(
            "error",
            error?.response?.data?.message || error?.response?.data?.msg
          );
        }
      } else if (error.request) {
      } else {
        openSnackbar("error", error?.message);
      }

      return Promise.reject(error);
    }
  );

  return (
    <BrowserRouter>
      <StackS />

      <TTFSnackbar
        severity={severity}
        message={message}
        open={openToast}
        setOpen={setOpenToast}
        duration={duration}
      />
    </BrowserRouter>
  );
}

export default App;